import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const ImageColumnWrapper = styled.div`
  align-self: center;
  flex-shrink: 0;
  width: 50px;
  margin-right: ${Spacing.S24};
`
